export default "__VITE_ASSET__BWQuXqHu__"